import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import HttpService from "../services/HttpServices";
import { toast } from "react-hot-toast";

const apiService = HttpService;

// Initial state of the slice
const initialState = {
  festivalData: [], // List of festivals
  festivalDetails: {}, // Details of a single festival
  error: null,
  loading: {
    fetchFestivals: false,
    createFestival: false,
    fetchFestivalById: false,
    editFestival: false,
    deleteFestivalById: false,
  },
};

// Async thunk for fetching festivals
export const fetchFestivals = createAsyncThunk(
  "festival/fetchFestivals",
  async (thunkAPI) => {
    try {
      const response = await apiService.get(`/admin/festivals`);
      // console.log("RES::", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data || error.message);
    }
  }
);

// Async thunk for creating a festival
export const createFestival = createAsyncThunk(
  "festival/createFestival",
  async (festivalData, { rejectWithValue }) => {
    try {
      const response = await apiService.post(`/admin/festivals`, festivalData);
      toast.success("Festival created successfully!");
      return response.data;
    } catch (error) {
      toast.error("Failed to create festival.");
      return rejectWithValue(error.response.data || error.message);
    }
  }
);

// Async thunk for fetching a festival by ID
export const fetchFestivalById = createAsyncThunk(
  "festival/fetchFestivalById",
  async (festivalId, { rejectWithValue }) => {
    try {
      const response = await apiService.get(`/admin/festivals/${festivalId}`);
      console.log('====================================\n');
      console.log("Festival Res::\n",response);
      console.log('====================================');
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data || error.message);
    }
  }
);

// Async thunk for editing a festival
export const editFestival = createAsyncThunk(
  "festival/editFestival",
  async ({ festivalId, festivalData }, { rejectWithValue }) => {
    console.log('====================================');
    console.log("Festival edit ::", festivalId, festivalData);
    console.log('====================================');
    try {
      const response = await apiService.put(
        `/admin/festivals/${festivalId}`,
        festivalData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data || error.message);
    }
  }
);

// Async thunk for deleting a festival by ID
export const deleteFestivalById = createAsyncThunk(
  "festival/deleteFestivalById",
  async (festivalId, { rejectWithValue }) => {
    try {
      await apiService.delete(`admin/festivals/${festivalId}`);
      toast.success("Festival deleted successfully!");
      return festivalId;
    } catch (error) {
      toast.error("Failed to delete festival.");
      return rejectWithValue(error.response.data || error.message);
    }
  }
);

// The festival slice
export const festivalSlice = createSlice({
  name: "festival",
  initialState,
  reducers: {
    resetFestivalState: (state) => {
      return { ...initialState, loading: { ...initialState.loading } };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchFestivals.pending, (state) => {
        state.loading.fetchFestivals = true;
      })
      .addCase(fetchFestivals.fulfilled, (state, action) => {
        state.loading.fetchFestivals = false;
        state.festivalData = action.payload.data;
      })
      .addCase(fetchFestivals.rejected, (state, action) => {
        state.loading.fetchFestivals = false;
        state.error = action.payload;
      })
      .addCase(createFestival.pending, (state) => {
        state.loading.createFestival = true;
      })
      .addCase(createFestival.fulfilled, (state, action) => {
        state.loading.createFestival = false;
        state.festivalData.push(action.payload);
      })
      .addCase(createFestival.rejected, (state, action) => {
        state.loading.createFestival = false;
        state.error = action.payload;
      })
      .addCase(fetchFestivalById.pending, (state) => {
        state.loading.fetchFestivalById = true;
      })
      .addCase(fetchFestivalById.fulfilled, (state, action) => {
        state.loading.fetchFestivalById = false;
        state.festivalDetails = action.payload.data;
      })
      .addCase(fetchFestivalById.rejected, (state, action) => {
        state.loading.fetchFestivalById = false;
        state.error = action.payload;
      })
      .addCase(editFestival.pending, (state) => {
        state.loading.editFestival = true;
      })
      .addCase(editFestival.fulfilled, (state, action) => {
        state.loading.editFestival = false;
        const index = state.festivalData.findIndex(
          (festival) => festival.id === action.payload.id
        );
        if (index !== -1) {
          state.festivalData[index] = action.payload;
        }
      })
      .addCase(editFestival.rejected, (state, action) => {
        state.loading.editFestival = false;
        state.error = action.payload;
      })
      .addCase(deleteFestivalById.pending, (state) => {
        state.loading.deleteFestivalById = true;
      })
      .addCase(deleteFestivalById.fulfilled, (state, action) => {
        state.loading.deleteFestivalById = false;
        state.festivalData = state.festivalData.filter(
          (festival) => festival.id !== action.payload
        );
      })
      .addCase(deleteFestivalById.rejected, (state, action) => {
        state.loading.deleteFestivalById = false;
        state.error = action.payload;
      });
  },
});

export const { resetFestivalState } = festivalSlice.actions;

export default festivalSlice.reducer;